import { Factory } from 'rosie';

Factory.define('RuleDisabledLoop')
  .attr('type', 'RULE_DISABLED_LOOP')
  .attr('ruleId', 'test-rule-id-disabled');

Factory.define('RuleDisabledLoopItem')
  .extend('ConversationItem')
  .attr('content', ['content'], content => Factory.attributes('RuleDisabledLoop', content));
